//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
	getValueByName
} from '@/common/js/dictionary.js'
import uniLoadMore from "@/components/uni-load-more/uni-load-more.vue"
export default {
	data() {
		return {
			page: {
				pageSize: 10,
				currentPage: 1,
				count: 0,
				loading: false,
			},
			count: 0,
			list: [],
			state: '',
			orderStatus: [{
					key: '',
					value: '全部'
				},
				{
					key: '10',
					value: '待付款'
				},
				{
					key: '20',
					value: '待使用'
				},
				{
					key: '90',
					value: '已完成'
				},
				{
					key: '1000',
					value: '退款'
				}
			],
		}
	},
	components: {
		uniLoadMore
	},
	onReachBottom() {
		if (this.list.length < this.count) {
			this.queryData()
		}
	},
	onLoad(event) {
		this.state = event.orderStatus ? event.orderStatus : ''
	},
	onShow() {
		this.list = []
		this.page.currentPage = 1
		this.queryData(this.state)
	},
	methods: {
		maxName(item) {
			return item.length > 20 ? item.substr(0, 20) + '...' : item
		},
		active(val) {
			this.state = val.key
			this.list = []
			this.page.currentPage = 1
			this.queryData(val.code)
		},
		//订单状态
		orderStatusName(item) { // 列表页状态，不要订单关闭后的状态
			let orderStatus = item.orderStatus
			let orderStatusName = item.orderStatusDescription
			if (this.state === 1000 && item.refundStatus === 36) {
				orderStatusName = '待退款'
			} else if ([20, 111, 112, 110].includes(orderStatus) && item.refundStatusDescription) {
				orderStatusName = item.refundStatusDescription
			}
			return orderStatusName
		},
		//列表
		queryData(val) {
			this.page.loading = true
			this.$ajax({
				method: 'post',
				url: '/weChat/personalCenter/order/queryPage',
				data: {
					orderStatus: val ? val : this.state,
					memberId: this.$store.state.userInfo.memberId,
					pageSize: this.page.pageSize,
					currentPage: this.page.currentPage
				}
			}).then(res => {
				this.list.push.apply(this.list, res.data)
				this.page.loading = false
				this.count = res.count
				this.page.currentPage += 1
			})
		},
	}
}
